import React from 'react';
import { Link } from 'react-router-dom';
import { FaUserShield, FaPlaneDeparture, FaHeadset, FaWallet } from 'react-icons/fa6'; // Icons import
export default function Why() {
  
  // Data for Features
  const features = [
    {
      id: 1,
      icon: <FaUserShield />,
      title: "Trusted Experience",
      desc: "With years of expertise, we ensure safe and secure travel planning."
    },
    {
      id: 2,
      icon: <FaPlaneDeparture />,
      title: "Customized Packages",
      desc: "We build holidays around your interests, not just standard itineraries."
    },
    {
      id: 3,
      icon: <FaHeadset />,
      title: "24/7 Support",
      desc: "From booking to return, our team is always just a call away."
    },
    {
      id: 4,
      icon: <FaWallet />,
      title: "Best Value",
      desc: "Luxury experiences at competitive prices with no hidden charges."
    }
  ];

  return (
    <div>
      {/* --- Section 1: Why Choose Us (Features) --- */}
      <section id="about" className="py-5 bg-white">
        <div className="container">
          
          {/* Section Header */}
          <div className="text-center mb-5 mw-800 mx-auto">
             <h6 className="text-uppercase text-danger fw-bold ls-2">Our Promise</h6>
             <h2 className="display-6 fw-bold text-dark">
                Why Choose <span className="text-highlight">Jawali Holidays?</span>
             </h2>
             <p className="text-muted mt-3 lead">
                Your happiness is our priority. Here is why thousands of travelers trust us with their dream vacations.
             </p>
          </div>

          {/* Features Grid */}
          <div className="row g-4">
            {features.map((item) => (
              <div className="col-md-6 col-lg-3" key={item.id}>
                <div className="feature-card text-center p-4 h-100">
                  <div className="icon-box mb-3">
                    {item.icon}
                  </div>
                  <h5 className="fw-bold mb-2">{item.title}</h5>
                  <p className="text-muted small mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* --- Section 2: Call To Action (Parallax Style) --- */}
      <section className="cta-section d-flex align-items-center justify-content-center text-center text-white">
        <div className="cta-overlay"></div> {/* Dark Overlay */}
        <div className="container position-relative z-2">
          <h2 className="display-5 fw-bold mb-3">Plan Your Dream Vacation Today!</h2>
          <p className="lead mb-4 text-light-50">
            Don't wait for the perfect moment. Take the moment and make it perfect.
          </p>
          <Link to="/contact" className="btn btn-warning btn-lg px-5 py-3 rounded-pill fw-bold shadow">
            Get in Touch Now
          </Link>
        </div>
      </section>
    </div>
  );
}